const doc = [({"header":"Ein Fehler ist aufgetreten", "body":"Dieser Teil der Website konnte aufgrund eines Fehlers nicht weiter ausgeführt werden."})];
module.exports = doc.length <= 1 ? doc[0] : doc;